import styled from "styled-components";

export const Wrapper = styled.div`
  min-width: auto;
  width: ${({ width }) => width || "274px"};

  .ant-picker-status-error.ant-picker {
    border-color: #ff4d4f;
  }
  .ant-picker {
    width: ${({ width }) => width || "100%"};
    height: ${({ height }) => height || "44px"};
    border-color: ${({ borderColor }) => borderColor || "#dfe1e7"};
    border-radius: 8px;
  }
  .ant-picker:hover,
  .ant-picker-focused {
    box-shadow: 0 0 2px #8b44ff !important;
    border-color: #6610f2 !important;
  }
  .ant-picker-focused {
    box-shadow: none;
    outline: 0;
  }
`;
